<template>
  <section id="contact" class="contact">
    <div class="container">
      <div class="col">
        <h2>Kontakt</h2>
        <address>
          <div class="col">
            <h3>Adres</h3>
            <span
              v-for="(item, index) in contactForm.address"
              v-bind:key="index"
            >
              {{ item }}
            </span>
          </div>
          <div class="col">
            <h3>E-mail</h3>
            <span>{{ contactForm.email }}</span>
          </div>
        </address>
        <form id="form" @submit.prevent="handleSubmit">
          <h3>{{ contactForm.writeMe }}</h3>
          <div class="FormField-wrapper FormField-wrapper--inputs">
            <div class="FormField">
              <label>
                <span>Imię i nazwisko</span>
                <input name="name" v-model="user.name" type="text" />
              </label>
            </div>
            <div class="FormField">
              <label>
                <span>Nazwa firmy</span>
                <input
                  name="companyName"
                  v-model="user.companyName"
                  type="text"
                />
              </label>
            </div>
            <div class="FormField">
              <label>
                <span>Adres e-mail</span>
                <input name="email" v-model="user.email" type="email" />
              </label>
            </div>
          </div>
          <div class="FormField-wrapper FormField-wrapper--textarea">
            <div class="FormField">
              <label>
                <span>Treść wiadomości</span>
                <textarea name="message" v-model="user.message"></textarea>
              </label>
            </div>
          </div>
          <div class="FormField-wrapper">
            <div class="FormField">
              <button id="submit" class="button">Wyślij</button>
            </div>
          </div>
        </form>
      </div>
      <div class="col">
        <div v-if="contactForm.showMap" class="map">
          <img src="@/assets/map.jpg" role="presentation" />
          <a
            href="https://www.google.pl/maps/place/Wita+Stwosza+3,+50-114+Wroc%C5%82aw/@51.1102667,17.0319746,17z/data=!3m1!4b1!4m5!3m4!1s0x470fc275c2af6559:0x66911714d442b9bf!8m2!3d51.1102667!4d17.0341633"
            target="blank"
          >
            <Pin />
          </a>
        </div>
      </div>
    </div>
    <Circles v-if="!hideCircles" />
  </section>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";

import Circles from "@/components/svg/Circles";
import Pin from "@/components/svg/Pin";

Vue.use(VueCookies);

export default {
  name: "ContactForm",
  components: {
    Circles,
    Pin,
  },
  props: {
    hideCircles: Boolean,
    contactForm: Object,
  },
  data() {
    return {
      user: {
        email: "",
        name: "",
        companyName: "",
        message: "",
      },
      submitted: false,
      canWeSendForm: {},
      tokenHasBeenGenerated: false,
      formElm: null,
      hasValueOrFocus: "hasValueOrFocus",
      url: null,
      formFields: null,
    };
  },
  mounted() {
    this.formElm = this.$vnode.elm;
    this.url = window.location.origin + "/form.php";
    this.formFields = this.formElm.querySelectorAll(".FormField");
    this.getToken();
    this.handleFocusInFormFields();
  },
  methods: {
    getToken() {
      let http = new XMLHttpRequest();

      http.open("POST", this.url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      http.onreadystatechange = () => {
        if (http.readyState === 4 && http.status === 200) {
          this.$cookies.set("ContactFormToken", http.responseText);
          this.tokenHasBeenGenerated = true;
        }
      };
    },
    handleSubmit() {
      const submit = this.formElm.querySelector("#submit");
      const submitMessage = submit.textContent;
      const name = encodeURIComponent(this.user.name);
      const email = encodeURIComponent(this.user.email);
      const companyName = encodeURIComponent(this.user.companyName);
      const message = encodeURIComponent(this.user.message);
      const params = `name=${name}&email=${email}&companyName=${companyName}&message=${message}`;
      const http = new XMLHttpRequest();

      http.open("POST", this.url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      submit.setAttribute("disabled", "disabled");

      let i = 0;
      const interval = setInterval(() => {
        if (i === 0 || i === 3) {
          submit.textContent = "";
          i = 0;
        }
        i++;
        submit.textContent += ".";
      }, 500);

      http.onloadend = () => {
        setTimeout(() => {
          submit.removeAttribute("disabled");
          submit.textContent = "Wysłano";
          clearInterval(interval);
          setTimeout(() => {
            this.clearForm();
            submit.textContent = submitMessage;
          }, 1000);
        }, 3000);
      };

      http.send(params);
    },
    clearForm() {
      this.formFields.forEach((formField) => {
        formField.classList.remove(this.hasValueOrFocus);

        formField.querySelectorAll("input, textarea").forEach((elm) => {
          elm.value = "";
        });
      });
    },
    handleFocusInFormFields() {
      this.formFields.forEach((formField) => {
        let input =
          formField.querySelector("input") ||
          formField.querySelector("textarea");

        if (input) {
          input.addEventListener("focus", () => {
            formField.classList.add(this.hasValueOrFocus);
          });
          input.addEventListener("change", () => {
            formField.classList.add(this.hasValueOrFocus);
          });
          input.addEventListener("blur", () => {
            input.value.length === 0 &&
              formField.classList.remove(this.hasValueOrFocus);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/colors";
@import "../../scss/utils";

@keyframes pulse {
  0% {
    transform: translate(27px, -8px) scale(1);
  }

  10% {
    transform: translate(27px, -8px) scale(1.4);
  }

  30% {
    transform: translate(27px, -8px) scale(1.1);
  }

  60% {
    transform: translate(27px, -8px) scale(1.3);
  }

  90% {
    transform: translate(27px, -8px) scale(1.1);
  }

  100% {
    transform: translate(27px, -8px) scale(1);
  }
}

.contact {
  position: relative;

  & >>> .Circles {
    width: 30%;
    position: absolute;
    right: 0;
    opacity: 0.1;
    top: 0;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;

    @include mobile() {
      max-width: 514px;
    }

    > .col {
      width: 50%;

      @include mobile() {
        width: 100%;
      }
    }

    .map {
      max-width: 535px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      .Pin {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        animation: pulse 2s infinite;

        path {
          fill: black;
        }
      }
    }

    @include mobile() {
      flex-direction: column;
    }
  }
}
</style>
